import type {
  BillingCycleWorksheetRead,
  CodeCodeEntry as GeneratedCodeCodeEntry,
  DiagnosisEntry as GeneratedDiagnosisEntry,
  ProcedureEntry as GeneratedProcedureEntry,
  Ub04Address as GeneratedUB04Address,
  Ub04Organization as GeneratedUB04Organization,
  Ub04PayerRowOutput as GeneratedUB04PayerRow,
  Ub04ProviderRow as GeneratedUB04ProviderRow,
  Ub04ServiceLine as GeneratedUB04ServiceLine,
  Ub04WorksheetData as GeneratedUB04WorksheetData,
  WorksheetConditionContextOutput,
} from '../../../services/api/types.gen';

export type OccurrenceRow = { code: string; date: string };
export type ValueRow = { code: string; amount: string };
export type OccurrenceSpanRow = {
  code: string;
  from_date: string;
  through_date: string;
};

export type UB04Address = GeneratedUB04Address;
export type UB04Organization = GeneratedUB04Organization;
export type WorksheetConditionContext = WorksheetConditionContextOutput;
export type UB04ServiceLine = GeneratedUB04ServiceLine;
export type UB04PayerRow = GeneratedUB04PayerRow;
export type DiagnosisEntry = GeneratedDiagnosisEntry;
export type ProcedureEntry = GeneratedProcedureEntry;
export type UB04ProviderRow = GeneratedUB04ProviderRow;
export type CodeCodeEntry = GeneratedCodeCodeEntry;
export type UB04WorksheetData = GeneratedUB04WorksheetData;

export type WorksheetApiRead = BillingCycleWorksheetRead;

export interface WorksheetEditorState {
  ub04: UB04WorksheetData;
}

export const MAX_UB04_SERVICE_LINES = 22;
export const MAX_UB04_REMARKS_LENGTH = 125;
// The claim carries at most two occurrence spans (FL 35-36); the backend
// rejects a third at save, so the editor must not let one be created.
export const MAX_UB04_OCCURRENCE_SPANS = 2;
// Two HI segments of 8 composites (TR3 max use 2) is the most occurrence
// codes an 837I claim can carry; mirrors MAX_UB04_OCCURRENCE_CODES in
// backend app/services/x12/constants.py. NOA readiness blocks a 17th.
export const MAX_UB04_OCCURRENCE_CODES = 16;
// The UB-04 claim worksheet accepts at most 10 occurrence-code entries
// (8 dedicated slots FL 31-34 a/b plus two of the span-capable FL 35-36
// slots); the backend worksheet model rejects an 11th at save.
export const MAX_WORKSHEET_OCCURRENCE_CODES = 10;
